import { ClipboardAccountOutlineIcon } from './ClipboardAccountOutlineIcon';

/**
 * author: James Coyle
 * id 80D8F0AA-0B3A-47ED-B342-8681E0DD7450
 * name clipboard-account-outline
 * version: 3.2.89
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/clipboard-account-outline.svg
 * tags
 * - Account / User 
 */
export const ClipboardPersonOutlineIcon = ClipboardAccountOutlineIcon;
export default ClipboardPersonOutlineIcon